<template>
  <div>
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="topage('/home/ticketPackage/ticketPackageAdd')"
    >
      分销设置
    </a-button>
    <a-table
      :columns="columns"
      :row-key="(record) => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a v-on:click.prevent="showModal">绑定上级</a>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk(operate)"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input v-model="uid" placeholder="请输入用户uid或者手机号码" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  getDistribution,
  updateDistribution,
  updatesuperior,
  getDistributionSeach,
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    align: "center",
  },
  {
    title: "用户昵称",
    dataIndex: "userNickName",
    align: "center",
  },
  {
    title: "用户手机",
    dataIndex: "userPhone",
    align: "center",
  },
  {
    title: "一级推荐人uid",
    dataIndex: "recommendAimsId",
    align: "center",
  },
  {
    title: "一级推荐人呢称",
    dataIndex: "recommendNickName",
    align: "center",
  },
  {
    title: "二级推荐人uid",
    dataIndex: "recommendTwoAimsId",
    align: "center",
  },
  {
    title: "二级推荐人昵称",
    dataIndex: "recommendTwoNickName",
    align: "center",
  },
  {
    title: "三级推荐人uid",
    dataIndex: "recommendThreeAimsId",
    align: "center",
  },
  {
    title: "三级推荐人昵称",
    dataIndex: "recommendThreeNickName",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      uid: "",
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getDistributionList();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getDistributionList() {
      getDistribution(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      getDistribution(10, this.pagination.current).then((res) => {
        this.data = res.data;
        console.log(res);
      });
      this.loading = false;
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    query() {
      this.loading = true;
      getDistributionSeach(
        10,
        1,
        this.formInline.userNickName,
        this.formInline.userPhone
      ).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    //
    showModal() {
      this.visible = true;
    },
    handleOk(row) {
      console.log(row);
      this.visible = false;
      updateDistribution(row.objId, this.uid).then((res) => {
        if (res.code === "0000") {
          this.getDistributionList();
          message.success(res.info);
        } else {
          message.error(res.info);
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/distribution/distributionHomeContent.vue